import { UseFormReturn } from "react-hook-form";
import { GoogleAuthProvider } from "firebase/auth";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@core/services/api/formatFirebaseError";
import { loginUserWithOAuth } from "../utils/loginUserWithOAuth";

type Args = {
  onSuccess?: (data: any) => void;
  onError?: () => void;
  form: UseFormReturn<any>;
};

export type { Args };

export function useGoogleLoginMutation({ onSuccess, form, onError }: Args) {
  return useMutation({
    mutationFn: async () => {
      return await loginUserWithOAuth(new GoogleAuthProvider(), onError);
    },
    onError: (error: Error) => {
      form.setError("root", {
        type: "manual",
        message: formatFirebaseError(error.message),
      });
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useGoogleLoginMutation;
